export default {

  compute: function (data, rowFields, columnFields, valueField, aggregateFunction ) {
    if (!data || data.length === 0) {
      return { rowHeaders: [], columnHeaders: [], data: {} };
    }

    if (!rowFields || rowFields.length === 0) {
      throw new Error("Row fields are required.");
    }

    if (!columnFields || columnFields.length === 0) {
      throw new Error("Column fields are required.");
    }

    const rowHeaders = new Set();
    const columnHeaders = new Set();
    const pivotData = {};

    const isCountBased = valueField === null || valueField === undefined;

    const defaultAggregateFunction = isCountBased
      ? (values) => values.length // Count
      : (values) => values.reduce((sum, val) => sum + val, 0); // Sum

    aggregateFunction = aggregateFunction || defaultAggregateFunction;

    for (const item of data) {
      const rowKey = rowFields.map((field) => item[field]).join("|"); // Use a consistent separator
      const columnKey = columnFields.map((field) => item[field]).join("|"); // Use a consistent separator

      rowHeaders.add(rowKey);
      columnHeaders.add(columnKey);

      if (!pivotData[rowKey]) {
        pivotData[rowKey] = {};
      }

      if (!pivotData[rowKey][columnKey]) {
        pivotData[rowKey][columnKey] = [];
      }

      pivotData[rowKey][columnKey].push(isCountBased ? 1 : item[valueField]);
    }

    // Apply the aggregate function
    for (const rowKey in pivotData) {
      for (const columnKey in pivotData[rowKey]) {
        pivotData[rowKey][columnKey] = aggregateFunction(
          pivotData[rowKey][columnKey]
        );
      }
    }
    
    let rh=Array.from(rowHeaders);
    rh.sort();

    return {
      rowFields: rowFields, columnFields: columnFields, valueField:valueField,
      rowHeaders: rh,
      rowHeadersSplitted: rh.map( (r) => { return r.split('|'); }),
      columnHeaders: Array.from(columnHeaders),
      columnHeadersSplitted: Array.from(columnHeaders).map( (r) => { return r.split('|'); }),
      data: pivotData,
    };
  },
  /*
    {
    rowHeaders: [
        '8|SAM',  '8|CUST',
        '8|UPG',  '3|SAM',
        '8|',     '2|UPG',
        '8|SPEC', '8|UPB',
        '8|UPBX', '3|UPG',
        '8|FC'
    ],
    columnHeaders: [ '3O|' ],
    data: {
        '8|SAM': { '3O|': NaN },
        '8|CUST': { '3O|': NaN },
        '8|UPG': { '3O|': NaN },
        '3|SAM': { '3O|': NaN },
        '8|': { '3O|': NaN },
        '2|UPG': { '3O|': NaN },
        '8|SPEC': { '3O|': NaN },
        '8|UPB': { '3O|': NaN },
        '8|UPBX': { '3O|': NaN },
        '3|UPG': { '3O|': NaN },
        '8|FC': { '3O|': NaN }
    }
    }
  */
  format: function( pivot, title) {
    let tableHTML = "<table class='ptpivot_table'>";

    tableHTML += `<tr class='ptpivot_row'><td class='ptpivot_col' colspan="${pivot.rowFields.length}">${title}</td>`;
    for (let c=0; c<pivot.columnHeaders.length; c++) {
        let col=pivot.columnHeaders[c];
            tableHTML += `<td class='ptpivot_cell'>${col}</td>`;
    }
    tableHTML += `</tr>`;

    pivot.rowHeaders.sort()

    for (let r=0; r<pivot.rowHeaders.length; r++) {
        let row=pivot.rowHeaders[r];
        tableHTML += `<tr class='ptpivot_row'>`;
        row2=row.split('|');
        row2=row2.join("</td><td class='ptpivot_cell'>")
        tableHTML += `<td class='ptpivot_cell'>${row2}</td>`;
        for (let c=0; c<pivot.columnHeaders.length; c++) {
            let col=pivot.columnHeaders[c];
            let d=pivot.data[row][col];
            if (d==undefined) d='';
             tableHTML += `<td class='ptpivot_cell'>${d}</td>`;
        }
        tableHTML += `</tr>`;
    }
    tableHTML += `</table>`;
    return tableHTML;

  }
};
